import { Goal, GoalProgressCount, ID } from '@griply/types';

import { getCompletionPercentage } from './get-completion-percentage';
import { getGoalCompletion } from './get-goal-completion';

export const getGoalCompletionPercentage = (
  goalId: ID | undefined,
  goals: Goal[],
  goalProgressCounts?: Map<ID, GoalProgressCount>,
): number | undefined => {
  if (!goalId) {
    return undefined;
  }
  const goal = goals.find((g) => g.id === goalId);
  if (!goal) {
    return undefined;
  }
  return getCompletionPercentage(
    getGoalCompletion(goal, { goals, goalProgressCounts }),
  );
};
